import React from "react";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { resolvePageIdFromPathname } from "@/common/Sidebar/sidebarNavConfig";
import {
  useCanViewPage,
  useResolvedRolePermissions,
} from "@/contexts/SuperAdminIdentityContext";

const RoutePermissionGuard: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation();
  const permissions = useResolvedRolePermissions();
  const pageId = resolvePageIdFromPathname(location.pathname);
  const canView = useCanViewPage(pageId ?? "");

  if (!pageId) {
    if (permissions?.isFullAccess) {
      return <>{children}</>;
    }
    return (
      <Container className="py-4">
        <h2>Access denied</h2>
        <p className="text-muted mb-0">
          Your role does not include permission to view this area.
        </p>
      </Container>
    );
  }

  if (!canView) {
    return (
      <Container className="py-4">
        <h2>Access denied</h2>
        <p className="text-muted mb-0">
          Your role does not include View permission for this page.
        </p>
      </Container>
    );
  }

  return <>{children}</>;
};

export default RoutePermissionGuard;
